
    @if (this.isLoading) {
      <mat-progress-bar mode="query"></mat-progress-bar>
    }

    <div style="max-width: 570px; margin: 0 auto; width: 100%;">
    <div style="display: flex; flex-direction: column; justify-content: space-between; height: 100%;">
        @for (day of this.Days; track day.getTime()) {
            <div style="display: flex; flex-direction: row; align-items: flex-start">
                
                <div class="day" >
                  {{day | date: 'E' }}

                  <span style="font-size: small; color: gray;" >{{day | date: 'dd MMM' }}</span>
                </div>
                <div>
                  @for (evt of getEvents(day); track evt.EventId) {
                    @if(evt.EventType === 'GAME') {
                      <app-game-event [Event]="evt" (deleteEvent)="deleteEventFromCalendar($event)"></app-game-event>
                    }
                    @if(evt.EventType === 'EVENT') {
                       <app-generic-event [Event]="evt"></app-generic-event>
                    }
                  }
                </div>
            </div>
        }
      
    </div>
    </div>

